<template>
    <div class="navbar-container d-flex content align-items-center">

        <!-- Nav Menu Toggler -->
        <ul class="nav navbar-nav d-xl-none">
            <li class="nav-item">
                <b-link class="nav-link" @click="toggleVerticalMenuActive">
                    <feather-icon icon="MenuIcon" size="21" />
                </b-link>
            </li>
        </ul>

        <!-- Left Col -->
        <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">

        </div>

        <b-navbar-nav class="nav align-items-center ml-auto">
            <b-nav-item-dropdown v-if="user"
                                 right
                                 toggle-class="d-flex align-items-center dropdown-user-link"
                                 class="dropdown-user">
                <template #button-content>
                    <div class="d-sm-flex d-none user-nav">
                        
                        <p class="user-name font-weight-bolder mb-0">
                            {{user.name}}
                        </p>
                        <span class="user-status">{{user.email}}</span>
                    </div>
                    <b-avatar size="40"
                              variant="light-primary"
                              badge
                              class="badge-minimal"
                              badge-variant="success" />
                </template>

                <!--<b-dropdown-divider />-->

                <b-dropdown-item href="/logout" link-class="d-flex align-items-center">
                    <feather-icon size="16"
                                  icon="LogOutIcon"
                                  class="mr-50" />
                    <span>Log ud</span>
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
    </div>
</template>

<script>
    import { initialAbility } from '@/libs/acl/config'

    export default {
        components: {},
        props: {
            toggleVerticalMenuActive: {
                type: Function,
                default: () => { },
            },
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        methods: {

        },
    }
</script>
